import { render, staticRenderFns } from "./ArchivedForm.vue?vue&type=template&id=453ab45d&scoped=true"
import script from "./ArchivedForm.vue?vue&type=script&lang=js"
export * from "./ArchivedForm.vue?vue&type=script&lang=js"
import style0 from "./ArchivedForm.vue?vue&type=style&index=0&id=453ab45d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ab45d",
  null
  
)

export default component.exports